export const ResourceLinks = {
  // expertDeskCare: 'https://exp.world/expertcare',
  supportDesk: 'https://support.expcloud.com/portal/en/newticket',
  agentComplianceFAQ:
    'https://exprealty.workplace.com/work/file_viewer/1066975214741653/?surface=POST_ATTACHMENT',
  agentComplianceFrame: 'https://exp.world/agentcompliance',
  teamServices: 'https://exp.world/teamservices',
  techSupportFrame: 'https://exp.world/techsupport-agent',
  training: 'http://expuniversity.com/',
  marketingResource: 'https://exptoolkit.com/canva',
  supportContact: '(833) 303-0610',
  supportEmail: 'support@exprealty.com',
  expertCareDesk: 'http://exp.world/expertcare',
  usBrokerTeams:
    'https://exp.world/home/destination/global/US%20Broker%20Rooms',
  canadianOperatorTeams:
    'https://exp.world/home/destination/global/Canadian%20Operations/Provinces',
} as const;
